import Moment from 'moment';

export const getMessageCreatedAt = (message) => Moment(message.createdAt).format('LT');

export default {
  getMessageCreatedAt,
};
